import { useCallback } from 'react';
import copyToClipboard from 'copy-to-clipboard';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

type Params = {
  textToCopy: string;
  successMessage?: string;
};

export function useCopyToClipboard({ textToCopy, successMessage = 'Link copied to clipboard' }: Params) {
  const sendSuccess = useCallback(() => WpToastManager.success(successMessage), [successMessage]);

  const sendError = useCallback(() => WpToastManager.danger('An error occurred with copying to the clipboard'), []);

  const handleCopyTextToClipboard = useCallback(() => {
    try {
      copyToClipboard(textToCopy);
      sendSuccess();
    } catch {
      sendError();
    }
  }, [sendSuccess, textToCopy, sendError]);

  return { onCopyTextToClipboard: handleCopyTextToClipboard };
}
